import api from '../base';

const CASES = '/casestudies';

export default {
  getCases() {
    return api.get(`${CASES}`);
  },

  getCaseById(caseId) {
    return api.get(`${CASES}/${caseId}`);
  }
};



// WEBPACK FOOTER //
// src/services/cases/service.js